'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alicd/next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendComponent = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(TrendComponent, _Component);

    function TrendComponent(props) {
        (0, _classCallCheck3.default)(this, TrendComponent);
        return (0, _possibleConstructorReturn3.default)(this, (TrendComponent.__proto__ || (0, _getPrototypeOf2.default)(TrendComponent)).call(this, props));
    }

    (0, _createClass3.default)(TrendComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                style = _props.style,
                type = _props.type,
                status = _props.status,
                text = _props.text,
                direction = _props.direction,
                _props$iconSize = _props.iconSize,
                iconSize = _props$iconSize === undefined ? 'xxs' : _props$iconSize,
                _props$iconColor = _props.iconColor,
                iconColor = _props$iconColor === undefined ? '#FF341A' : _props$iconColor;

            if (status === 'good') {
                iconColor = '#54BF4C'; // 1470cc
            }

            if (direction === 'l') {
                return _react2.default.createElement(
                    'span',
                    { className: "cn-trend " + className, style: style },
                    text,
                    _react2.default.createElement(_next.Icon, { type: "arrow-" + type + "-fills", size: iconSize, style: { color: iconColor, marginLeft: 8 } }),
                    this.props.children
                );
            } else {
                return _react2.default.createElement(
                    'span',
                    { className: "cn-trend " + className, style: style },
                    text,
                    this.props.children,
                    _react2.default.createElement(_next.Icon, { type: "arrow-" + type + "-fills", size: iconSize, style: { color: iconColor, marginLeft: 5 } })
                );
            }
        }
    }]);
    return TrendComponent;
}(_react.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    type: _propTypes2.default.string,
    status: _propTypes2.default.oneOf(['good', 'bad']),
    text: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    direction: _propTypes2.default.string
}, _class.defaultProps = {
    type: 'up',
    status: 'good',
    direction: 'r'
}, _temp);
exports.default = TrendComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Trend.js
// module id = 606
// module chunks = 0